import React, { useRef, useState , useImperativeHandle, useEffect} from "react";
import EmailEditor from "react-email-editor";


const EmailEditorTest = React.forwardRef(({setEditorContent, handleAdvancedEditorContent, editorContent, type}, ref) => {
  const editorRef = useRef(null);
  const [previewHtml, setPreviewHtml] = useState("");
  const [showPreview, setShowPreview] = useState(false);

      const onReady = (unlayer) => {
      console.log("✅ Editor is fully ready.");

      try {
        // Load from props if provided, otherwise load hardcoded template
  const editor = editorRef.current?.editor;


          if (!editor) {
    console.warn("⚠️ Editor not yet ready, retrying...");
    setTimeout(onReady, 2000);
    return;
  }    
       if (editorContent  && editorRef.current) {
        const designData = type == '1' ? JSON.parse(editorContent) : editorContent;

        unlayer.loadDesign(designData);
        console.log("✅ Design loaded into editor");
      } 
      
    }catch (err) {
        console.error("❌ Failed to load design:", err);
      }
    };

const handleEditorLoad = () => {
  console.log("✅ Email Editor loaded successfully!");
  const editor = editorRef.current?.editor;

  if (!editor) {
    console.warn("⚠️ Editor not yet ready, retrying...");
    setTimeout(handleEditorLoad, 300);
    return;
  }

  console.log("Editor Content:", editorContent);

  if (editorContent  && editorRef.current) {
    try {

      const design = JSON.parse(editorContent); // must be valid JSON design
      editor.loadDesign({"counters":{"u_column":2,"u_row":2,"u_content_text":1,"u_content_heading":1},"body":{"id":"4blLrvaTC6","rows":[{"id":"eoX_ANS6gd","cells":[1],"columns":[{"id":"hFJfLo_9Wh","contents":[{"id":"WjI-DQkXp8","type":"text","values":{"text":"<p style=\"line-height: 140%;\">This is a new Text block. Change the text.</p>","containerPadding":"10px","anchor":"","fontSize":"14px","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"displayCondition":null,"_styleGuide":null,"_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"locked":false,"_languages":{}}}],"values":{"backgroundColor":"","padding":"0px","border":{},"borderRadius":"0px","_meta":{"htmlID":"u_column_2","htmlClassNames":"u_column"},"deletable":true,"locked":false}}],"values":{"displayCondition":null,"columns":false,"_styleGuide":null,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"center"},"padding":"0px","anchor":"","_meta":{"htmlID":"u_row_2","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"locked":false}},{"id":"Xj_TxT4r3N","cells":[1],"columns":[{"id":"_bVHAyEKLt","contents":[{"id":"NK4NE4944D","type":"heading","values":{"text":"Heading","containerPadding":"10px","anchor":"","headingType":"h1","fontSize":"22px","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"displayCondition":null,"_styleGuide":null,"_meta":{"htmlID":"u_content_heading_1","htmlClassNames":"u_content_heading"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"locked":false,"_languages":{}}}],"values":{"backgroundColor":"","padding":"0px","border":{},"borderRadius":"0px","_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"},"deletable":true,"locked":false}}],"values":{"displayCondition":null,"columns":false,"_styleGuide":null,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"center","customPosition":["50%","50%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"locked":false}}],"headers":[],"footers":[],"values":{"_styleGuide":null,"popupPosition":"center","popupDisplayDelay":0,"popupWidth":"600px","popupHeight":"auto","borderRadius":"10px","contentAlign":"center","contentVerticalAlign":"center","contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"textColor":"#000000","popupBackgroundColor":"#FFFFFF","popupBackgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"cover","position":"center"},"popupOverlay_backgroundColor":"rgba(0, 0, 0, 0.1)","popupCloseButton_position":"top-right","popupCloseButton_backgroundColor":"#DDDDDD","popupCloseButton_iconColor":"#000000","popupCloseButton_borderRadius":"0px","popupCloseButton_margin":"0px","popupCloseButton_action":{"name":"close_popup","attrs":{"onClick":"document.querySelector('.u-popup-container').style.display = 'none';"}},"language":{},"backgroundColor":"#F7F8F9","preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"center"},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":20});

      console.log("Loaded Unlayer design into editor");
    } catch (err) {
      console.warn("⚠️ Prefill skipped — editorContent is not a valid Unlayer design JSON.");
    }
  }
};

// useEffect(()=>{
//   // if (editorRef.current) {
//     // editorRef.current.editor.loadHtml(editorContent);
//     handleEditorLoad();
//   // }
// }, [editorContent]);

  const exportHtml = () => {
    editorRef.current.editor.exportHtml((data) => {
      const { html, design } = data;
      console.log("Exported design:", JSON.stringify(design));
      console.log(typeof design);
      setPreviewHtml(html);
      // setEditorContent(html);
      setShowPreview(true);
    });
  };

    useImperativeHandle(ref, () => ({
    exportHtml: (callback) => {
      editorRef.current?.editor?.exportHtml((data) => {
        callback(data.html, data.design, type=1);
      });
    },
  }));

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Header Bar */}
      <div
        style={{
          background: "#2563eb",
          color: "white",
          padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ margin: 0 }}>📧 Email Template Builder</h2>
        <div>
          <button
            onClick={exportHtml}
            style={{
              background: "white",
              color: "#2563eb",
              border: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              fontWeight: "bold",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Preview
          </button>
        </div>
      </div>

      {/* Email Editor */}
      <div style={{ flexGrow: 1 }}>
        <EmailEditor ref={editorRef} onReady={onReady}  />
      </div>

      {/* Preview Modal */}
      {showPreview && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={() => setShowPreview(false)}
        >
          <div
            style={{
              background: "white",
              width: "90%",
              height: "90%",
              borderRadius: "8px",
              overflow: "auto",
              position: "relative",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                position: "sticky",
                top: 0,
                background: "#2563eb",
                color: "white",
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <h3 style={{ margin: 0 }}>Preview</h3>
              <button
                onClick={() => setShowPreview(false)}
                style={{
                  background: "white",
                  color: "#2563eb",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 12px",
                  cursor: "pointer",
                }}
              >
                Close ✖
              </button>
            </div>

            <iframe
              title="Email Preview"
              srcDoc={previewHtml}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
});

export default EmailEditorTest;


// import React, {
//   useRef,
//   useState,
//   useImperativeHandle,
//   useEffect,
// } from "react";
// import EmailEditor from "react-email-editor";

// const EmailEditorTest = React.forwardRef(
//   ({ setEditorContent, handleAdvancedEditorContent, editorContent }, ref) => {
//     const editorRef = useRef(null);
//     const [previewHtml, setPreviewHtml] = useState("");
//     const [showPreview, setShowPreview] = useState(false);

//     // ✅ Hardcoded design (for testing)
//     const designData = {
//       counters: { u_column: 2, u_row: 2, u_content_text: 1, u_content_heading: 1 },
//       body: {
//         id: "4blLrvaTC6",
//         rows: [
//           {
//             id: "eoX_ANS6gd",
//             cells: [1],
//             columns: [
//               {
//                 id: "hFJfLo_9Wh",
//                 contents: [
//                   {
//                     id: "WjI-DQkXp8",
//                     type: "text",
//                     values: {
//                       text: `<p style="line-height: 140%;">This is a new Text block. Change the text.</p>`,
//                       containerPadding: "10px",
//                     },
//                   },
//                 ],
//               },
//             ],
//           },
//           {
//             id: "Xj_TxT4r3N",
//             cells: [1],
//             columns: [
//               {
//                 id: "_bVHAyEKLt",
//                 contents: [
//                   {
//                     id: "NK4NE4944D",
//                     type: "heading",
//                     values: {
//                       text: "Heading",
//                       headingType: "h1",
//                       fontSize: "22px",
//                       textAlign: "left",
//                     },
//                   },
//                 ],
//               },
//             ],
//           },
//         ],
//       },
//       schemaVersion: 20,
//     };

//     // ✅ Fires when the Unlayer editor is fully initialized
//     const onReady = (unlayer) => {
//       console.log("✅ Editor is fully ready.");

//       try {
//         // Load from props if provided, otherwise load hardcoded template
//         const design = designData;

//         unlayer.loadDesign(design);
//         console.log("✅ Design loaded into editor");
//       } catch (err) {
//         console.error("❌ Failed to load design:", err);
//       }
//     };

//     // Export as HTML + design JSON
//     const exportHtml = () => {
//       editorRef.current.editor.exportHtml((data) => {
//         const { html, design } = data;
//         console.log("Exported design:", design);
//         setPreviewHtml(html);
//         setShowPreview(true);
//       });
//     };

//     // Expose exportHtml to parent via ref
//     useImperativeHandle(ref, () => ({
//       exportHtml: (callback) => {
//         editorRef.current?.editor?.exportHtml((data) => callback(data.html));
//       },
//     }));

//     return (
//       <div
//         style={{
//           height: "100vh",
//           width: "100%",
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//         }}
//       >
//         {/* Header Bar */}
//         <div
//           style={{
//             background: "#2563eb",
//             color: "white",
//             padding: "12px 20px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <h2 style={{ margin: 0 }}>📧 Email Template Builder</h2>
//           <button
//             onClick={exportHtml}
//             style={{
//               background: "white",
//               color: "#2563eb",
//               border: "none",
//               borderRadius: "6px",
//               padding: "8px 16px",
//               fontWeight: "bold",
//               cursor: "pointer",
//             }}
//           >
//             Preview
//           </button>
//         </div>

//         {/* Email Editor */}
//         <div style={{ flexGrow: 1 }}>
//           <EmailEditor ref={editorRef} onReady={onReady} />
//         </div>

//         {/* Preview Modal */}
//         {showPreview && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               background: "rgba(0,0,0,0.7)",
//               zIndex: 1000,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               padding: "20px",
//             }}
//             onClick={() => setShowPreview(false)}
//           >
//             <div
//               style={{
//                 background: "white",
//                 width: "90%",
//                 height: "90%",
//                 borderRadius: "8px",
//                 overflow: "auto",
//                 position: "relative",
//                 boxShadow: "0 0 20px rgba(0,0,0,0.3)",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div
//                 style={{
//                   position: "sticky",
//                   top: 0,
//                   background: "#2563eb",
//                   color: "white",
//                   padding: "10px",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   zIndex: 10,
//                 }}
//               >
//                 <h3 style={{ margin: 0 }}>Preview</h3>
//                 <button
//                   onClick={() => setShowPreview(false)}
//                   style={{
//                     background: "white",
//                     color: "#2563eb",
//                     border: "none",
//                     borderRadius: "4px",
//                     padding: "6px 12px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Close ✖
//                 </button>
//               </div>

//               <iframe
//                 title="Email Preview"
//                 srcDoc={previewHtml}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   border: "none",
//                 }}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
// );

// export default EmailEditorTest;
